import { RadioControl } from "../../create-request/models/form/FormControlRadio";

export const useStandingAuthModel: RadioControl = {
    title: 'Use a standing authorization?',
    controlName: 'useStandingAuth',
    radios: [
        {
            value: 'yes',
            label: ['Yes'],
        },
        {
            value: 'no',
            label: ['No'],
        },
    ],
    validationMessage: 'Select yes or no'
};

export function yesNoModel(title: string, controlName: string): RadioControl {
    return {
        title: title,
        controlName: controlName,
        radios: [
            {
                value: 'yes',
                label: ['Yes'],
            },
            {
                value: 'no',
                label: ['No'],
            },
        ],
        validationMessage: 'Select yes or no'
    }
}

export const frequencySelectorModel: RadioControl = {
    title: 'Frequency',
    controlName: 'frequency',
    radios: [
        {
            value: 'onetime',
            label: ['One-time'],
        },
        {
            value: 'recurring',
            label: ['Recurring']
        },
        {
            value: 'total-distribution',
            label: ['Total distribution']
        }
    ],
    validationMessage: 'Select a frequency'
};

export const bsloaModel: RadioControl = {
    title: 'Use a standing authorization?',
    controlName: 'useStandingAuth',
    radios: [
        {
            value: 'yes',
            label: ['Yes, use a standing authorization'],
        },
        {
            value: 'bundled',
            label: ['Yes, use a bundled standing authorization'],
        },
        {
            value: 'no',
            label: [
                'No, create a one-time or recurring transaction that will require client authorization',
            ],
        },
    ],
    validationMessage: 'Select an option',
};

export const useBundledModel: RadioControl = {
    title: 'Select one of the following',
    controlName: 'useBundledStandingAuth',
    radios: [
        {
            value: 'yes',
            label: ['Bundled standing authorization profile'],
        },
        {
            value: 'no',
            label: ["One-time (using firm's bundled authorization)"],
        }
    ],
    validationMessage: 'Select an option'
};  